import kebabCase from 'lodash/kebabCase'

import { ExternalSchoolFields } from 'main/gql/externalSchool'
import { SchoolFields } from 'main/gql/school'
import { SchoolListingFields } from 'main/gql/schoolListing'

export function externalSchoolPagePath(externalSchool: ExternalSchoolFields) {
  const { address, slug } = externalSchool
  const [state, city] = address ? [address.state, address.city] : [null, null]

  return pathFromParts({ slug, state, city })
}

export function schoolPagePath(school: SchoolFields) {
  const { address, slug } = school
  const [state, city] = address ? [address.state, address.city] : [null, null]

  return pathFromParts({ slug, state, city })
}

export function schoolListingPagePath(listing: SchoolListingFields) {
  const {
    location: { state, city },
    slug,
  } = listing

  return pathFromParts({ slug, state, city })
}

interface IParts {
  slug: string
  state: string | null
  city: string | null
}

function pathFromParts(parts: IParts) {
  const { state, city, slug } = parts
  if (!state || !city) return `/${slug}`

  return `/${kebabCase(state)}/${kebabCase(city)}/${slug}`
}
